import React from 'react';
import qs from 'qs';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import Dropdown from '../../Dropdown/Default';
import { doRequest } from './helpers';

const Filter = ({
  size, title, items, queryRequest, classHelper, forAssign, dispatchAction,
}) => {
  const location = useLocation();
  const history = useHistory();

  const searchArr = qs.parse(location.search.substring(1));

  const doRequestFunc = (key) => doRequest(key, searchArr, location, history, queryRequest);

  return (
    <Dropdown
      size={size}
      title={title}
      items={items}
      handleSelect={doRequestFunc}
      classForBtnDrop={`custom__filter-dropdown--button${classHelper ? ` ${classHelper}` : ''}`}
      queryRequest={queryRequest}
      forAssign={forAssign}
      dispatchAction={dispatchAction}
    />
  );
};

Filter.propTypes = {
  size: PropTypes.string,
  title: PropTypes.string,
  items: PropTypes.array,
  queryRequest: PropTypes.string,
  classHelper: PropTypes.string,
  forAssign: PropTypes.bool,
  dispatchAction: PropTypes.func,
};

Filter.defaultProps = {
  title: 'default',
  items: [],
};

export default Filter;
